import { graphierQL } from 'utils'
import {
  UpdateMapAccessMutation,
  UpdateMapAccessMutationVariables
} from '~map-preview/types/__generated/gql/graphql'

export const updateMapAccess = async (
  variables: UpdateMapAccessMutationVariables
) => {
  return await graphierQL<
    UpdateMapAccessMutation,
    UpdateMapAccessMutationVariables
  >({
    query: /* GraphQL */ `
      mutation UpdateMapAccess($id: ID!, $isPublic: Boolean!) {
        updateMapAccess(id: $id, isPublic: $isPublic) {
          id
        }
      }
    `,
    variables,
    useToken: true
  }).then((res) => res.updateMapAccess)
}
